import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("attributes.label.my_custom_groups"))),
      ]),
      _vm._t("default"),
      _c(VBreadcrumbs, {
        staticClass: "pa-0 py-2 text--black",
        attrs: { items: _vm.getBreadcrumbs },
      }),
      _c(VRow, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              VCard,
              { staticClass: "without-filter" },
              [
                _c(VDataTable, {
                  staticClass: "text-center table-inca",
                  attrs: {
                    headers: _vm.headers,
                    "items-per-page": _vm.pagination.limit,
                    items: _vm.Items,
                    page: _vm.pagination.current,
                    "sticky-header": true,
                    "hide-default-footer": "",
                    hover: "",
                    responsive: "",
                  },
                  on: {
                    "update:page": function ($event) {
                      return _vm.$set(_vm.pagination, "current", $event)
                    },
                    pagination: function ($event) {
                      _vm.pagination.total = $event.itemsLength
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item.actions",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _c(
                            VTooltip,
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(VHover, {
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var hover = ref.hover
                                                  return [
                                                    _c(
                                                      VIcon,
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            staticClass: "mr-1",
                                                            attrs: {
                                                              medium: "",
                                                              color: hover
                                                                ? "#0021CF"
                                                                : "#4B4D53",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.viewItem(
                                                                  item,
                                                                  _vm.DIALOG_VIEW_GROUP_ATTRIBUTE
                                                                )
                                                              },
                                                            },
                                                          },
                                                          "v-icon",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [_vm._v(" icon-view ")]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("attributes.button.view_detail")
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            VTooltip,
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(VHover, {
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var hover = ref.hover
                                                  return [
                                                    _c(
                                                      VIcon,
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            attrs: {
                                                              medium: "",
                                                              color:
                                                                item.status &&
                                                                hover
                                                                  ? "#F03063"
                                                                  : item.status &&
                                                                    !hover
                                                                  ? "#0021CF"
                                                                  : !item.status &&
                                                                    !hover
                                                                  ? "#4B4D53"
                                                                  : "#0021CF",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.addItem(
                                                                  item
                                                                )
                                                              },
                                                            },
                                                          },
                                                          "v-icon",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              item.status &&
                                                                hover
                                                                ? "mdi-minus-circle-outline"
                                                                : item.status &&
                                                                  !hover
                                                                ? "mdi-check-circle-outline"
                                                                : !item.status &&
                                                                  !hover
                                                                ? "icon-add"
                                                                : "mdi-check-circle-outline"
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("attributes.button.add"))),
                              ]),
                            ]
                          ),
                          _c(
                            VMenu,
                            {
                              attrs: { bottom: "", right: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          VBtn,
                                          _vm._g(
                                            _vm._b(
                                              { attrs: { icon: "" } },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(VIcon, [
                                              _vm._v("mdi-dots-vertical"),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c(
                                VList,
                                [
                                  _c(
                                    VListItem,
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.EditItem(
                                            item,
                                            _vm.DIALOG_EDIT_GROUP_ATTRIBUTE
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        VListItemIcon,
                                        [_c(VIcon, [_vm._v("icon-edit")])],
                                        1
                                      ),
                                      _c(
                                        VListItemContent,
                                        [
                                          _c(VListItemTitle, [
                                            _vm._v("Editar"),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VListItem,
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.DeleteItem(
                                            item,
                                            _vm.DIALOG_DELETE_GROUP_ATTRIBUTE
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        VListItemIcon,
                                        [_c(VIcon, [_vm._v("icon-delete")])],
                                        1
                                      ),
                                      _c(
                                        VListItemContent,
                                        [
                                          _c(VListItemTitle, [
                                            _vm._v("Delete"),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("pagination-vue", { attrs: { pagination: _vm.pagination } }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("dialogs-component", {
        ref: _vm.DIALOG_VIEW_GROUP_ATTRIBUTE,
        attrs: {
          title: _vm.$t("attributes.label.title_view_attributes"),
          "show-buttons": false,
          width: 900,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  VRow,
                  [
                    _c("view-attribute-group-component", {
                      attrs: { item: _vm.selected },
                      on: {
                        close: function ($event) {
                          return _vm.onCloseDialog(
                            _vm.DIALOG_VIEW_GROUP_ATTRIBUTE
                          )
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialogs-component", {
        ref: _vm.DIALOG_EDIT_GROUP_ATTRIBUTE,
        attrs: {
          title: _vm.$t("titles.edit_group_attributes"),
          "show-buttons": false,
          width: 900,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  VRow,
                  [
                    _c("edit-attribute-group-component", {
                      attrs: { item: _vm.selected },
                      on: {
                        close: function ($event) {
                          return _vm.onCloseDialog(
                            _vm.DIALOG_EDIT_GROUP_ATTRIBUTE
                          )
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialog-confirmation-component", {
        ref: _vm.DIALOG_DELETE_GROUP_ATTRIBUTE,
        attrs: {
          title: "Confirmación",
          text: "¿Esta seguro de eliminar este grupo?",
        },
        on: { onConfirm: _vm.onAceptarDelete },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }